import { render, staticRenderFns } from "./WorkflowDefinition.vue?vue&type=template&id=0c87f968&"
import script from "./WorkflowDefinition.vue?vue&type=script&lang=js&"
export * from "./WorkflowDefinition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports